import {
  type BaseActionObject,
  type InternalMachineOptions,
  type ResolveTypegenMeta,
  type ServiceMap,
  assign,
} from 'xstate'

import type {
  MachineContext,
  MachineEvents,
  MachineStateSchema,
} from '~/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'

export const ExpressReplacementActions: InternalMachineOptions<
  MachineContext,
  MachineEvents,
  ResolveTypegenMeta<
    MachineStateSchema,
    MachineEvents,
    BaseActionObject,
    ServiceMap
  >,
  true
>['actions'] = {
  storeXrData: assign({
    xrData: (_, event) => event.data,
  }),
}
